// extracted by mini-css-extract-plugin
export default {"root":"App_root__ZeVwS","header":"App_header__Yjvu6","menu":"App_menu__Mvnj2","content":"App_content__TAGMX"};